import { gql } from '@apollo/client';

export default gql`
  mutation ($input: NotifyExpiredAdRenewInput!) {
    notifyExpiredAdRenew(input: $input)
  }
`;
